// extracted by mini-css-extract-plugin
module.exports = {"container":"UtilitySection_container__hFeE8","border":"UtilitySection_border__88Rjt"};